import * as React from "react";
const SvgFiRrStarOctogram = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-star-octogram_svg__a)">
      <path
        fill="#062147"
        d="M21.77 8.948a1.24 1.24 0 0 1-.7-1.7 3.24 3.24 0 0 0-4.315-4.316 1.24 1.24 0 0 1-1.7-.7 3.239 3.239 0 0 0-6.1 0 1.24 1.24 0 0 1-1.7.7 3.239 3.239 0 0 0-4.321 4.317 1.237 1.237 0 0 1-.7 1.7 3.24 3.24 0 0 0 0 6.1 1.24 1.24 0 0 1 .705 1.7 3.238 3.238 0 0 0 4.31 4.317 1.24 1.24 0 0 1 1.7.7 3.239 3.239 0 0 0 6.1 0 1.24 1.24 0 0 1 1.7-.7 3.239 3.239 0 0 0 4.317-4.315 1.24 1.24 0 0 1 .7-1.7 3.239 3.239 0 0 0 0-6.1zm-.67 4.219a3.24 3.24 0 0 0-1.84 4.442 1.24 1.24 0 0 1-1.652 1.65 3.24 3.24 0 0 0-4.441 1.84 1.238 1.238 0 0 1-2.334 0 3.24 3.24 0 0 0-4.442-1.84 1.24 1.24 0 0 1-1.65-1.651A3.24 3.24 0 0 0 2.9 13.167a1.24 1.24 0 0 1 0-2.334A3.237 3.237 0 0 0 4.74 6.39 1.239 1.239 0 0 1 6.39 4.74a3.24 3.24 0 0 0 4.443-1.84 1.238 1.238 0 0 1 2.334 0 3.24 3.24 0 0 0 4.442 1.84 1.24 1.24 0 0 1 1.65 1.652 3.24 3.24 0 0 0 1.84 4.44 1.238 1.238 0 0 1 0 2.335"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-star-octogram_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrStarOctogram;
